import Interceptor from 'fetch-intercept'
import router from '../router'
import Config from '../config'

console.log(window.location.href);

const baseURL = Config.BASE_API_URL;
const logout = function () {
  if (window.location.href.indexOf("instagram1a") > 0) {
    return;
  } else {
    return fetch(baseURL + 'auth', {
      method: 'DELETE'
    })
      .then(function (response) {
        localStorage.removeItem("sessionId");
        localStorage.removeItem("userId");
        localStorage.removeItem("userEmail");
        localStorage.removeItem("admin");
        router.push("/pages/login");
        if (response && response.status && response.status === 200) {
          return response.json();
        } else {
          return Promise.reject();
        }
      });
  }
};

export default {
  name: 'service',
  unregister: Interceptor.register({

    request: function (url, config) {

      if (config && config.bypassInterceptor)
        return [url, config];

      if (!config) {
        config = {
          headers: new Headers()
        }
      } else if (!config.headers) {
        config.headers = new Headers();
      }

      if (localStorage.sessionId) {
        config.headers.append('Conectados-Auth', localStorage.sessionId);
      }

      if (config.method && (config.method == 'POST' || config.method == 'PUT')) {
        config.headers.append('Content-Type', "application/json");
      }

      return [url, config];
    },
    requestError: function (error) {
      // Called when an error occured during another 'request' interceptor call
      return Promise.reject(error);
    },
    response: function (response) {
      if (response.status == 401) {
        logout();
      } else {
        return response;
      }

    },
    responseError: function (error) {
      return Promise.reject(error);
    }
  }),
  login: function (signinData) {
    return fetch(baseURL + 'auth', {
      method: 'POST',
      body: JSON.stringify(signinData)
    })
      .then(function (response) {
        if (response && response.status && response.status === 200) {
          return response.json();
        } else {
          return Promise.reject();
        }
      })
  },
  logout: logout,
  register: function (signupData) {
    return fetch(baseURL + 'user', {
      method: 'POST',
      body: JSON.stringify(signupData)
    })
      .then(function (response) {
        if (response && response.status && response.status === 200) {
          return response.json();
        } else {
          return response.json().then(json => { return Promise.reject(json) });
        }
      })
  },
  saveFavoriteTemplate: function (templateData) {
    return fetch(baseURL + 'save-favorite-template', {
      method: 'POST',
      body: JSON.stringify(templateData)
    })
      .then(async function (response) {
        if (response && response.status && response.status === 200) {
          return response.json();
        } else {
          return Promise.reject(await response.json());
        }
      })
  },
  deleteFavoriteTemplate: function (templateId) {
    return fetch(baseURL + 'delete-favorite-template/' + templateId, {
      method: 'DELETE'
    })
      .then(function (response) {
        if (response && response.status && response.status === 200) {
          return response.json();
        } else {
          return Promise.reject();
        }
      })
  },
  deleteTemplateMine: function (templateId) {
    return fetch(baseURL + 'delete-favorite-template/' + templateId, {
      method: 'DELETE'
    })
      .then(function (response) {
        if (response && response.status && response.status === 200) {
          return response.json();
        } else {
          return Promise.reject();
        }
      })
  },
  saveTemplate: function (templateData) {
    return fetch(baseURL + 'save-template', {
      method: 'POST',
      body: JSON.stringify(templateData)
    })
      .then(function (response) {
        if (response && response.status && response.status === 200) {
          return response.json();
        } else {
          return Promise.reject();
        }
      })
  },
  saveAdminTemplate: function (templateData) {
    return fetch(baseURL + 'save-admin-template', {
      method: 'POST',
      body: JSON.stringify(templateData)
    })
      .then(function (response) {
        if (response && response.status && response.status === 200) {
          return response.json();
        } else {
          return Promise.reject();
        }
      })
  },
  carouselSaveTemplate: function(templateId, carouselEditionId, customColorsCarousel, selectedColorId, selectedCarouselLine) {
    return fetch(baseURL + 'carousel-save-template', {
      method: 'POST',
      body: JSON.stringify({templateId: templateId, carouselEditionId: carouselEditionId, customColorsCarousel: customColorsCarousel, selectedColorId: selectedColorId, selectedCarouselLine: selectedCarouselLine})
    })
    .then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    })
  },
  carouselIgnoreTemplate: function(temporaryTemplateId) {
    return fetch(baseURL + 'carousel-ignore-template', {
      method: 'POST',
      body: JSON.stringify({temporaryTemplateId: temporaryTemplateId})
    })
    .then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    })
  },
  updateCreation: function(creation) {
    return fetch(baseURL + 'creation', {
      method: 'PUT',
      body: JSON.stringify({creation: creation})
    })
    .then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    })
  },
  addCreation: function(creation) {
    return fetch(baseURL + 'creation', {
      method: 'POST',
      body: JSON.stringify({creation: creation})
    })
    .then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    })
  },
  getCreations: function(search, requestSearch, categories) {
    return fetch(baseURL + 'creations', {
      method:'POST',
      body: JSON.stringify({search: search, requestSearch: requestSearch, categories: categories})
    })
    .then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    })
  },
  deleteCreation: function(id) {
    return fetch(baseURL + 'creation/' + id, {
      method: 'DELETE'
    })
    .then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    })
  },
  getCreation: function(id) {
    return fetch(baseURL + 'creation/' + id)
    .then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    })
  },
  getHistory: function () {
    return fetch(baseURL + 'history')
    .then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    })
  },
  getAdminDashboardData: function () {
    return fetch(baseURL + 'admin-dashboard-data')
    .then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    })
  },
  getAdmins: function () {
    return fetch(baseURL + 'admins')
    .then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    })
  },
  getScreenshotFromHtml: function (html, css, width, height) {
    return fetch(baseURL + 'screenshot-from-data', {
      method: 'POST',
      body: JSON.stringify({html: html, css: css, width: width, height: height})
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    })
  },
  getAdminDashboardCategories: function () {
    return fetch(baseURL + 'admin-dashboard-categories')
    .then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    })
  },
  updateAdminTemplate: function (templateData) {
    return fetch(baseURL + 'update-admin-template', {
      method: 'POST',
      body: JSON.stringify(templateData)
    })
      .then(function (response) {
        if (response && response.status && response.status === 200) {
          return response.json();
        } else {
          return Promise.reject();
        }
      })
  },
  deleteAdminTemplate: function (templateId) {
    return fetch(baseURL + 'delete-admin-template/' + templateId, {
      method: 'DELETE'
    })
      .then(function (response) {
        if (response && response.status && response.status === 200) {
          return response.json();
        } else {
          return Promise.reject();
        }
      })
  },
  searchTemplates: function (filterOptions) {
    if (filterOptions == null) {
      return this.getAllTemplates({ stories: filterOptions.stories });
    }
    else {
      return fetch(baseURL + "search-templates", {
        method: "POST",
        body: JSON.stringify(filterOptions)
      }).then(function (response) {
        if (response && response.status && response.status === 200) {
          return response.json();
        } else {
          return Promise.reject();
        }
      });
    }
  },
  getFirstPaymentData: function() {
    return fetch(baseURL + 'first-payment-by-day')
    .then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    })
  },
  registerColorUse: function (color) {
    return fetch(baseURL + "register-color-use", {
      method: "POST",
      body: JSON.stringify({color: color})
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getFirstPaymentDataMonth: function() {
    return fetch(baseURL + 'first-payment-by-month')
    .then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    })
  },
  searchExercises: function (filterOptions) {
    if (filterOptions == null) {
      return this.getAllTemplates();
    }
    else {
      return fetch(baseURL + "search-exercises", {
        method: "POST",
        body: JSON.stringify(filterOptions)
      }).then(function (response) {
        if (response && response.status && response.status === 200) {
          return response.json();
        } else {
          return Promise.reject();
        }
      });
    }
  },
  requestRandomBonus: function () {
    return fetch(baseURL + "random-bonus", {
      method: "GET"
    }).then(async function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        let errorResult = await response.json();
        return Promise.reject(errorResult);
      }
    });
  },
  requestFreeCredits: function () {
    return fetch(baseURL + "request-free-credits", {
      method: "GET"
    }).then(async function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        let errorResult = await response.json();
        return Promise.reject(errorResult);
      }
    });
  },
  getAllExerciseCategories: function () {
    return fetch(baseURL + "exercise-categories", {
      method: "GET"
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getAllCategories: function () {
    return fetch(baseURL + "categories", {
      method: "GET"
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getAllStoryCategories: function () {
    return fetch(baseURL + "story-categories", {
      method: "GET"
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getMyDocuments: function () {
    return fetch(baseURL + "document/mine", {
      method: "GET"
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getEbookMine: function () {
    return fetch(baseURL + "ebook/mine", {
      method: "GET"
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getBanner: function () {
    return fetch(baseURL + "banner", {
      method: "GET"
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getEbooks: function () {
    return fetch(baseURL + "ebook", {
      method: "GET"
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getDocuments: function () {
    return fetch(baseURL + "document-template", {
      method: "GET"
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getSites: function () {
    return fetch(baseURL + "site-template", {
      method: "GET"
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getEbookPrice: function () {
    return fetch(baseURL + "ebook-price", {
      method: "GET"
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getEbook: function (id) {
    return fetch(baseURL + "ebook/" + id, {
      method: "GET"
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getEbookPages: function (id) {
    return fetch(baseURL + "ebook-pages/" + id, {
      method: "GET"
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getEbookCategories: function (id) {
    return fetch(baseURL + "ebook-categories/" + id, {
      method: "GET"
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getEbookCovers: function (id) {
    return fetch(baseURL + "ebook-covers/" + id, {
      method: "GET"
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getChallenge: function (id) {
    return fetch(baseURL + "challenge/" + id, {
      method: "GET"
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getFullChallenge: function (id) {
    return fetch(baseURL + "full-challenge/" + id, {
      method: "GET"
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getAllCategoriesAndUserCategories: function (story) {
    return fetch(baseURL + "categories-system-user/?story=" + (story ? 1 : 0), {
      method: "GET"
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getClubData: function () {
    return fetch(baseURL + "club", {
      method: "GET"
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getUserCategories: function () {
    return fetch(baseURL + "categories-mine", {
      method: "POST",
      body: JSON.stringify({ "idUser": localStorage.userId })
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getAllTemplates: function (filter) {
    return fetch(baseURL + "templates", {
      method: "POST",
      body: JSON.stringify(filter)
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getTemplatesInfo: function (filter) {
    return fetch(baseURL + "templates-info", {
      method: "POST",
      body: JSON.stringify(filter)
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getTemplateEdition: function (filter) {
    return fetch(baseURL + "user-edition", {
      method: "POST",
      body: JSON.stringify(filter)
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getTemplateUses: function (filter) {
    return fetch(baseURL + "template-editions", {
      method: "POST",
      body: JSON.stringify(filter)
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getUserTemplates: function (categoriesList, currentPage, expressEdition, advancedEdition) {
    return fetch(baseURL + "templates-mine", {
      method: "POST",
      body: JSON.stringify({ categoriesList, "currentPage": currentPage, "expressEdition": expressEdition, "advancedEdition": advancedEdition })
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getFavoriteTemplates: function (categoriesList, currentPage, expressEdition, advancedEdition) {
    return fetch(baseURL + "favorites", {
      method: "POST",
      body: JSON.stringify({ categoriesList, "currentPage": currentPage, "expressEdition": expressEdition, "advancedEdition": advancedEdition })
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getFonts: function () {
    return fetch(baseURL + "fonts", {
      method: "GET"
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getNotificationRedirectUrl: function () {
    return fetch(baseURL + "notification-redirecting", {
      method: "GET"
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getElements: function () {
    return fetch(baseURL + "elements", {
      method: "GET"
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  removeFont: function (font) {
    return fetch(baseURL + "remove-font", {
      method: "POST",
      body: JSON.stringify({font: font})
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  addFont: function (font) {
    return fetch(baseURL + "add-font", {
      method: "POST",
      body: JSON.stringify({font: font})
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getTemporaryDesign: function (id) {
    return fetch(baseURL + "temporary-templates/" + id, {
      method: "GET"
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  sendTrackingData: function (trackingData) {
    return fetch(baseURL + "tracking-data", {
      method: "POST",
      body: JSON.stringify({trackingData: trackingData})
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  saveDocument: function (pages) {
    return fetch(baseURL + "save-document", {
      method: "POST",
      body: JSON.stringify({pages: pages})
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getSitePageById: function (idSitePage) {
    return fetch(baseURL + "site-page/" + idSitePage, {}).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getSiteByUserId: function (idUser) {
    return fetch(baseURL + "site/" + idUser, {}).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  updateSitePageSessions: function (siteId, sessions, colors) {
    return fetch(baseURL + "update-site-page-sessions/" + siteId, {
      method: "POST",
      body: JSON.stringify({sessions: sessions, colors: colors})
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  setSitePageTemplate: function (pageId, templateId) {
    return fetch(baseURL + "site-page-template", {
      method: "POST",
      body: JSON.stringify({pageId: pageId, templateId: templateId})
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject(response);
      }
    }).catch(error => {
      if (error) {
        return error.json().then(result => Promise.reject(result));
      } else {
        return Promise.reject();
      }
    });
  },
  removeSitePage: function (pageId) {
    return fetch(baseURL + "site-page/" + pageId, {
      method: "DELETE"
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return response.json().then(json => { return Promise.reject(json) });
      }
    })
  },
  saveSitePageConfiguration: function (sitePageConfiguration) {
    return fetch(baseURL + "site-page-configuration", {
      method: "POST",
      body: JSON.stringify({sitePageConfiguration: sitePageConfiguration})
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject(response);
      }
    }).catch(error => {
      if (error) {
        return error.json().then(result => Promise.reject(result));
      } else {
        return Promise.reject();
      }
    });
  },
  saveSiteConfiguration: function (siteConfiguration) {
    return fetch(baseURL + "site-configuration", {
      method: "POST",
      body: JSON.stringify({siteConfiguration: siteConfiguration})
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject(response);
      }
    }).catch(error => {
      if (error) {
        return error.json().then(result => Promise.reject(result));
      } else {
        return Promise.reject();
      }
    });
  },
  getServers: function () {
    return fetch(baseURL + "servers", {}).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getCalendar: function () {
    return fetch(baseURL + "calendar", {}).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getAvailableSiteTemplates: function () {
    return fetch(baseURL + "site-templates", {}).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getSiteSubscriptions: function () {
    return fetch(baseURL + "site-subscriptions", {}).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  saveSite: function (sessions) {
    return fetch(baseURL + "save-site", {
      method: "POST",
      body: JSON.stringify({sessions: sessions})
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getDocumentTemplate: function(id) {
    return fetch(baseURL + "document-template/" + id, {
      method: "GET"
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getSiteTemplate: function(id) {
    return fetch(baseURL + "site-template/" + id, {
      method: "GET"
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getUser: function (userId) {
    return fetch(baseURL + "get-user/" + userId, {
      method: "GET"
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getCarouselTemplateById: function (templateId, carouselEditionId) {
    return fetch(baseURL + "carousel-template/" + templateId + "/" + carouselEditionId).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getTemplateById: function (templateId) {
    return fetch(baseURL + "template/" + templateId).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getTemplateUserCategories: function (id) {
    return fetch(baseURL + "template-categories-mine/" + id, {
      method: "GET"
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getTemplateCategories: function (id) {
    return fetch(baseURL + "template-categories/" + id, {
      method: "GET"
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  saveCategoriesMine: function (categoriesList, idTemplate) {
    if (categoriesList != null || categoriesList.length > 1) {
      return fetch(baseURL + "save-categories-mine", {
        method: "POST",
        body: JSON.stringify({ categoriesList, "idUser": localStorage.userId, "idTemplate": idTemplate })
      }).then(function (response) {
        if (response && response.status && response.status === 200) {
          return response.json();
        } else {
          return Promise.reject();
        }
      });
    }
  },
  subscribe: function (token) {
    return fetch(baseURL + "subscribe", {
      method: "POST",
      body: JSON.stringify({ "token": token })
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return response.json().then(json => { return Promise.reject(json) });
      }
    });
  },
  subscribePagseguroSingle: function (plan, method, coupon) {
    let subscribePagseguroUrl = baseURL + "subscribe-pagseguro-single/" + plan + "/" + method;

    if (coupon) {
      subscribePagseguroUrl += "/" + coupon;
    }
    
    return fetch(subscribePagseguroUrl, {
      method: "POST"
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return response.json().then(json => { return Promise.reject(json) });
      }
    });
  },
  subscribePagseguro: function (plan, method, coupon, includeEbook) {
    let subscribePagseguroUrl = baseURL + "subscribe-pagseguro/" + plan + "/" + method;

    if (coupon) {
      subscribePagseguroUrl += "/" + coupon;
    }
    
    return fetch(subscribePagseguroUrl, {
      method: "POST",
      body: JSON.stringify({includeEbook: includeEbook})
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return response.json().then(json => { return Promise.reject(json) });
      }
    });
  },
  getPaymentHistory: function (userId) {
    let url = "";

    if (userId) {
      url = "payment-history/" + userId;
    } else {
      url = "payment-history";
    }

    return fetch(baseURL + url, {
      method: "GET"
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getPlatformDetails: function (searchParams) {
    return fetch(baseURL + "platform-details", {
      method: "POST",
      body: JSON.stringify(searchParams)
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getSalesDetails: function (searchParams) {
    return fetch(baseURL + "sales-details", {
      method: "POST",
      body: JSON.stringify(searchParams)
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getWhitelabelDetails: function (searchParams) {
    return fetch(baseURL + "whitelabel-details", {
      method: "POST",
      body: JSON.stringify(searchParams)
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getMe: function () {
    return fetch(baseURL + "me").then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getNotificacao: function () {
   
    return fetch(baseURL + "testenotificacao", {
      method: "GET"
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getWhitelabel: function () {
    return fetch(baseURL + "whitelabel").then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json().then((response) => {
          if (response && response.whitelabel) {
            localStorage.removeItem("whitelabelName");
            localStorage.removeItem("templateName");
            localStorage.removeItem("logo300x300");
            localStorage.removeItem("logo500x100");
            localStorage.removeItem("youtubeTutorial");
            localStorage.removeItem("supportEmail");
            localStorage.removeItem("supportWhatsapp");

            localStorage.whitelabelName = response.whitelabel.name;
            localStorage.templateName = response.whitelabel.templateName;
            localStorage.logo300x300 = response.whitelabel.logo300x300;
            localStorage.logo500x100 = response.whitelabel.logo500x100;

            if (response.whitelabel.youtubeTutorial) {
              localStorage.youtubeTutorial = response.whitelabel.youtubeTutorial;
            }
            if (response.whitelabel.supportEmail) {
              localStorage.supportEmail = response.whitelabel.supportEmail;
            }
            if (response.whitelabel.supportWhatsapp) {
              localStorage.supportWhatsapp = response.whitelabel.supportWhatsapp;
            }
            return response;
          } else {
            return undefined;
          }
        });
      } else {
        return undefined;
      }
    });
  },
  requestPasswordReset: function (email) {
    return fetch(baseURL + "request-password-reset", {
      method: "POST",
      body: JSON.stringify({ email: email })
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  allowEbook: function (id) {
    return fetch(baseURL + "allow-ebook", {
      method: "POST",
      body: JSON.stringify({ id: id })
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  allowChallengeAccess: function (id) {
    return fetch(baseURL + "allow-challenge-access", {
      method: "POST",
      body: JSON.stringify({ id: id })
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  saveCustomEbookEmail: function (email, id) {
    return fetch(baseURL + "save-custom-ebook-email", {
      method: "POST",
      body: JSON.stringify({ email: email, id: id })
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  customChooseEbookPages: function (selectedPages, idEbook) {
    return fetch(baseURL + "custom-choose-ebook-pages", {
      method: "POST",
      body: JSON.stringify({ selectedPages: selectedPages, idEbook: idEbook })
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getDesignHistory: function () {
    return fetch(baseURL + "design-history").then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  updateEbookPages: function (idEbookRequest, selectedPages) {
    return fetch(baseURL + "update-ebook-pages/" + idEbookRequest, {
      method: "POST",
      body: JSON.stringify({ selectedPages: selectedPages})
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  chooseEbookPages: function (selectedPages, idEbook) {
    return fetch(baseURL + "choose-ebook-pages", {
      method: "POST",
      body: JSON.stringify({ selectedPages: selectedPages, idEbook: idEbook })
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  saveCustomEbookPage: function (temporaryTemplateId, idEbookRequest) {
    return fetch(baseURL + "save-ebook-page", {
      method: "POST",
      body: JSON.stringify({ temporaryTemplateId: temporaryTemplateId, idEbookRequest: idEbookRequest })
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  createEbookRequestV2: function (img, ebookId) {
    return fetch(baseURL + "ebook-request-v2", {
      method: "POST",
      body: JSON.stringify({ coverUrl: img, ebookId: ebookId })
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  createCustomEbookRequestV2: function (img) {
    return fetch(baseURL + "custom-ebook-request", {
      method: "POST",
      body: JSON.stringify({ coverUrl: img })
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getCustomEbookPages: function (ebookRequestId) {
    return fetch(baseURL + "custom-ebook-pages/" + ebookRequestId).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getEbookRequestPages: function (ebookRequestId) {
    return fetch(baseURL + "ebook-request-pages/" + ebookRequestId).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  saveToken: function (token) {
    return fetch(baseURL + "save-token", {
      method: "POST",
      body: JSON.stringify({ token: token })
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  createNewPassword: function (password, passwordConfirmation, token) {
    return fetch(baseURL + "reset-password", {
      method: "POST",
      body: JSON.stringify({ password: password, passwordConfirmation: passwordConfirmation, passwordResetToken: token })
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return response.json().then(json => { return Promise.reject(json) });
      }
    });
  },
  getPlans: function (coupon) {
    let getPlansUrl = baseURL + "plans";

    if (coupon) {
      getPlansUrl += "/" + coupon;
    }

    return fetch(getPlansUrl).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getTutorials: function () {
    return fetch(baseURL + "tutorials").then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  updateUser: function (updateData, userId) {
    return fetch(baseURL + "update-user/" + userId, {
      method: "POST",
      body: JSON.stringify(updateData)
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return response.json().then(json => { return Promise.reject(json) });
      }
    });
  },
  updateMe: function (updateData) {
    return fetch(baseURL + "me", {
      method: "POST",
      body: JSON.stringify(updateData)
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return response.json().then(json => { return Promise.reject(json) });
      }
    });
  },
  getUploads: function () {
    return fetch(baseURL + "get-uploads").then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return response.json().then(json => { return Promise.reject(json) });
      }
    })
  },
  getRelatedPosts: function (templateId) {
    return fetch(baseURL + "related/" +templateId ).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return response.json().then(json => { return Promise.reject(json) });
      }
    })
  },
  getResellers: function () {
    return fetch(baseURL + "get-resellers").then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return response.json().then(json => { return Promise.reject(json) });
      }
    })
  },
  removeUpload: function (url) {
    let urlParts = url.split("/");
    let imageName = urlParts[urlParts.length - 1];

    return fetch(baseURL + "remove-upload/" + imageName, {
      method: "DELETE"
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return response.json().then(json => { return Promise.reject(json) });
      }
    })
  },
  useCredits: function (idtemplate) {
    return fetch(baseURL + "use-credits/" + idtemplate).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getProductivityByAdmin: function () {
    return fetch(baseURL + "productivity-by-admin").then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getLatestCreationActions: function () {
    return fetch(baseURL + "latest-creation-actions").then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  useTemplate: function (idtemplate) {
    return fetch(baseURL + "use-template/" + idtemplate).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getContacts: function (idUser) {
    return fetch(baseURL + "contacts/" + idUser).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getSources: function (idUser) {
    return fetch(baseURL + "sources").then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  cancelSubscription: function () {
    return fetch(baseURL + "cancel-subscription", { 
      method: "POST"
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  saveColor: function (color) {
    return fetch(baseURL + "color", { 
      method: "POST",
      body: JSON.stringify({ color: color })
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  updateColor: function (color) {
    console.log(color);
    return fetch(baseURL + "color", { 
      method: "PUT",
      body: JSON.stringify({ color: color })
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  getColors: function () {
    return fetch(baseURL + "color", { 
      method: "GET"
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  registerContact: function (idUser, description) {
    return fetch(baseURL + "contact/" + idUser, { 
      method: "POST",
      body: JSON.stringify({ description: description })
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  registerSource: function (description, type) {
    return fetch(baseURL + "source", { 
      method: "POST",
      body: JSON.stringify({ description: description, type: type })
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  approveSleeker: function (id, description) {
    return fetch(baseURL + "sleeker-approve/" + id, { 
      method: "POST"
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  reviewSleeker: function (id, description) {
    return fetch(baseURL + "sleeker-review/" + id, { 
      method: "POST"
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  registerSale: function (idUser, description) {
    return fetch(baseURL + "sale/" + idUser, { 
      method: "POST",
      body: JSON.stringify({ description: description })
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  openTicket: function (text) {
    return fetch(baseURL + "open-ticket", {
      method: "POST",
      body: JSON.stringify({ text: text })
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return response.json().then(json => { return Promise.reject(json) });
      }
    });
  },
  submitUserIdentifier: function (userIdentifier) {
    return fetch(baseURL + "submit-identifier", {
      method: "POST",
      body: JSON.stringify({ userIdentifier: userIdentifier })
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return response.json().then(json => { return Promise.reject(json) });
      }
    });
  },
  whatsappLinkClick: function (userId) {
    return fetch(baseURL + "whatsapp-link-click", {
      method: "POST",
      body: JSON.stringify({ userId: userId })
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return response.json().then(json => { return Promise.reject(json) });
      }
    });
  },
  reportError: function (error) {
    return fetch(baseURL + "report-error", {
      method: "POST",
      body: JSON.stringify({ error: error })
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return response.json().then(json => { return Promise.reject(json) });
      }
    });
  },  requestSleeker: function (text) {
    return fetch(baseURL + "request-sleeker", {
      method: "POST",
      body: JSON.stringify({ text: text })
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return response.json().then(json => { return Promise.reject(json) });
      }
    });
  },
  confirmEmail: function (token) {
    return fetch(baseURL + "confirm-email/" + token, {
      method: "POST",
      body: JSON.stringify({ confirmationToken: token })
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return response.json().then(json => { return Promise.reject(json) });
      }
    });
  },
  approvePayment: function (paymentId) {
    return fetch(baseURL + "approve-payment", {
      method: "POST",
      body: JSON.stringify({ paymentId: paymentId })
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return response.json().then(json => { return Promise.reject(json) });
      }
    });
  },
  addDays: function (resellerId, days) {
    return fetch(baseURL + "reseller-days", {
      method: "POST",
      body: JSON.stringify({ resellerId: resellerId, days: days })
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return response.json().then(json => { return Promise.reject(json) });
      }
    });
  },
  confirmUserEmail: function (user) {
    return fetch(baseURL + "confirm-email", {
      method: "POST",
      body: JSON.stringify({ userId: user})
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return response.json().then(json => { return Promise.reject(json) });
      }
    });
  },
  addUserDays: function (user, days, credits, subscriptionType, planType) {
    return fetch(baseURL + "user-days", {
      method: "POST",
      body: JSON.stringify({ userId: user, days: days, credits: credits, subscriptionType: subscriptionType, planType: planType})
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return response.json().then(json => { return Promise.reject(json) });
      }
    });
  },
  resendConfirmationEmail: function () {
    return fetch(baseURL + "resend-confirmation-email", {
      method: "POST"
    });
  },
  getCreationControl: function (id, newController) {
    return fetch(baseURL + "creation/" + id + "/control/" + newController, {
      method: "POST"
    });
  },
  releaseCreationControl: function (id) {
    return fetch(baseURL + "creation/" + id + "/control", {
      method: "DELETE"
    });
  },
  saveExpressTemplateFromText(text) {
    return fetch(baseURL + "save-json-express", {
      method: "POST",
      body: text
    }).then(async function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        let errorInfo = { initialized: true };
        this.reportError("PONTO 1 DO ERRO");
        try {
          errorInfo.status = response.status;
          this.reportError("PONTO 2 DO ERRO");
          try {
            errorInfo.result = await response.text();
            this.reportError("PONTO 3 DO ERRO");
          } catch {
            errorInfo.result = "Impossible do parse to text";
            this.reportError("PONTO 4 DO ERRO");
            
          }
        } catch {
          this.reportError("PONTO 5 DO ERRO");
        }

        return Promise.reject(errorInfo);
      }
    });
  },
  saveExpressTemplate: function (json, previewData, story, originalTemplateId, creation, customColors) {
    console.log("Creation ")
    console.log(creation)
    return fetch(baseURL + "save-json-express", {
      method: "POST",
      body: JSON.stringify({ json: json, newTemplate: previewData, story: story, originalTemplateId: originalTemplateId, creationId: creation, customColors: customColors})
    }).then(async function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        let errorInfo = { initialized: true };
        this.reportError("PONTO 1 DO ERRO");
        try {
          errorInfo.status = response.status;
          this.reportError("PONTO 2 DO ERRO");
          try {
            errorInfo.result = await response.text();
            this.reportError("PONTO 3 DO ERRO");
          } catch {
            errorInfo.result = "Impossible do parse to text";
            this.reportError("PONTO 4 DO ERRO");
            
          }
        } catch {
          this.reportError("PONTO 5 DO ERRO");
        }

        return Promise.reject(errorInfo);
      }
    });
  },
  updateExpressTemplate: function (json, previewData, story, originalTemplateId, creation) {
    return fetch(baseURL + "update-json-express", {
      method: "POST",
      body: JSON.stringify({ json: json, newTemplate: previewData, story: story, originalTemplateId: originalTemplateId, creationId: creation })
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  },
  updateExpressTemplateBlob: function (json, previewData, story, originalTemplateId, creation) {
    console.log(previewData)
    return fetch(baseURL + "update-json-express-blob", {
      method: "POST",
      body: JSON.stringify({ json: json, newTemplate: previewData, story: story, originalTemplateId: originalTemplateId, creationId: creation })
    }).then(function (response) {
      if (response && response.status && response.status === 200) {
        return response.json();
      } else {
        return Promise.reject();
      }
    });
  }
};